<template>
    <div>
        <member-list-link :memberData="memberList" :listLayout="listLayout"></member-list-link>
    </div>
</template>

<script>
    import filterMixins from "@/mixins/filterMixins";
    import listMixins from "@/mixins/listMixins";
    import MemberListLink from "@/components/member/MemberListLink";
    import memberUtil from "@/components/member/memberUtil";
    export default {
        name: "MemberHomeComponent",
        mixins: [filterMixins,listMixins,memberUtil],
        components: {MemberListLink},
        props: {
            memberType:'',
        },
        data() {
            return {
                listLayout: '',
                getFunc: '',
                listApiParamSet: {},
                memberList:[]
            }
        },
        beforeRouterEnter() {
        },
        created() {
            this.initConfig()
        },
        mounted() {
            this.getList();
        },
        beforeDestroy() {
        },
        destroyed(){
        },
        computed: {},
        methods: {
            initConfig() {
                let memberConfig = this.returnMemberConfig(this.memberType);
                this.listLayout = memberConfig.listLayout;
                this.listApiParamSet = memberConfig.listApiParamSet;
                this.getFunc = memberConfig.getFunc;
            },
            getList(){
                this.$api.$member[this.getFunc](this.listApiParamSet).then(res => res.Data.Result).then(res =>{
                    if(res.Info.type == 1){
                        this.memberList = res.List
                    }
                })
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>